// The renovation scale, in words.
//
// `ai_renovation` is stored as 1-5 (the scale itself is defined in
// backend/services/listing_analysis.py, and mirrored as CONDITION_LEVELS in
// backend/services/listing_filters.py). A bare "4" is fine on an internal page where everyone
// knows the scale and meaningless to a client reading a share link, so anything client-facing
// renders the word instead.
//
// One map, because the filter panel's Condition dropdown and the client page must not drift
// into disagreeing about what level 4 is called.

export const RENOVATION_LABELS = {
  1: "Gut needed",
  2: "Original",
  3: "Updated",
  4: "Renovated",
  5: "New",
};

/**
 * "4" | 4 -> "Renovated". Returns the original value for anything off the scale (the column is
 * a VARCHAR and has held non-numeric text), and null for empty — so a caller can hide the row
 * rather than print "null".
 */
export function renovationLabel(value) {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(value);
  if (!Number.isInteger(n) || !(n in RENOVATION_LABELS)) return String(value);
  return RENOVATION_LABELS[n];
}
